module.exports = __webpack_public_path__ + "images/bannerES-9cae36a2fe270d7c9faf763e328da8cb.jpg";